import axios from '../../http';

import router from '../../routes';

const state = {
  results: [],
  filters: {
    suppliers: [],
    isFixed: 'any',
    isGreen: 'any',
    switchable: true,
    payMethod: 'MonthlyDirectDebit'
  },
  big6: [2, 7, 111, 11, 15, 16]
};

const getters = {
  results: (state, getters, rootState, rootGetters) => {
    const { filters, results } = state;
    const fixedMap = {
      fixed: true,
      variable: false
    };
    const greenMap = {
      yes: true,
      no: false
    };

    return results.filter(({ isFixed, supplierId, isGreen, payMethod, switchOption }) => {
      const suppliers = filters.suppliers.filter(({ selected }) => selected);
      const findSupplier = suppliers.find(({ id }) => id == supplierId);
      const filterIsFixed = filters.isFixed == 'any' ? true : fixedMap[filters.isFixed] == isFixed;
      const filterIsGreen = filters.isGreen == 'any' ? true : greenMap[filters.isGreen] == isGreen;
      const filterPaymethod = filters.payMethod.toLowerCase() == payMethod.toLowerCase();
      const filterSwitchable = filters.switchable == false ? (switchOption == 'None' || switchOption !== 'None') : switchOption !== 'None';

      if (suppliers.length > 0) {
        return findSupplier && filterIsFixed && filterIsGreen && filterSwitchable && filterPaymethod;
      }

      return filterIsFixed && filterIsGreen && filterSwitchable && filterPaymethod;
    })
      .map(item => ({ ...item, monthlyCost: Math.ceil(item.totalCost / 12) }));
  }
};

const actions = {
  async getQuoteResults({ state, rootState, commit, dispatch }) {
    const { quote } = rootState.storage;

    try {
      dispatch('page_loader/start', 0, { root: true });
      const { data, status } = await axios({
        method: 'POST',
        url: '/request/results/detail',
        data: quote
      });

      if (status == 200) {
        commit('updateUniqueSuppliers', data.resultsInDetailDto.resultsInDetail);
        commit('updateState', {
          prop: 'results',
          value: data.resultsInDetailDto.resultsInDetail
        });
        await dispatch('storage/save', {
          prop: 'uuid',
          value: data.resultsInDetailDto.uuid
        }, { root: true });
      }

      dispatch('page_loader/stop', null, { root: true });
    } catch (error) {
      commit('updateState', {
        prop: 'results',
        value: []
      });
      dispatch('page_loader/stop', null, { root: true });
    }
  },
  async getCurrentTariff({ rootState, commit, dispatch }, tariffId) {
    const { switchId, switchType, proposedPayMethod } = rootState.storage.quote;
    const res = await axios({
      method: 'POST',
      url: '/request/ppp',
      data: {
        proposedPayMethod,
        switchId,
        switchType,
        tariffId,
        tariffValidToDate: null,
        onCurrentTariff: true
      }
    });

    commit('updateState', {
      prop: 'currentTariff',
      value: res.data.pppDto.electricityChosenPersonalProjectionPlan
    });
  },
  async switchNow({ rootState, dispatch }, { tariffId }) {
    const { quote } = rootState.storage;
    const { switchId, switchType, proposedPayMethod } = quote;
    const switchPlan = {};

    if (switchType == 'electricityToElectricity' || switchType == 'dualDistinctToDualConsolidated' || switchType == 'dualConsolidatedToDualConsolidated') {
      switchPlan.electricity = {
        tariffId,
        payMethod: proposedPayMethod
      };
    }

    if (switchType == 'gasToGas' || switchType == 'dualDistinctToDualConsolidated' || switchType == 'dualConsolidatedToDualConsolidated') {
      switchPlan.gas = {
        tariffId,
        payMethod: proposedPayMethod
      };
    }

    try {
      dispatch('page_loader/start', 0, { root: true });

      const { data, status } = await axios({
        method: 'POST',
        url: '/request/switch/pro/key',
        data: {
          switchType, switchPlan, switchId
        }
      });

      if (status == 200) {
        dispatch('storage/save', {
          prop: 'switchKey',
          value: data.geniusSwitchKeyDto.switchKey
        }, { root: true });

        router.push({ name: 'personalDetails' });
      }

      dispatch('page_loader/stop', null, { root: true });
    } catch (error) {
      dispatch('page_loader/stop', null, { root: true });
    }
  },
  async processSwitchHold({ dispatch }, route) {
    if (!route.id) return true;

    try {
      const decoded = decodeBase64(route.id);

      validateDecodeBase64(decoded, [
        'completionDate', 'switchId', 'switchType', 'proposedPayMethod',
        'electricitySmartMeterInstalled', 'gasSmartMeterInstalled'
      ]);

      await dispatch('storage/save', {
        prop: 'switchKey',
        value: decoded.switchKey
      }, { root: true });
      await dispatch('storage/save', {
        prop: 'quote',
        value: {
          completionDate: decoded.completionDate,
          switchId: decoded.switchId,
          switchType: decoded.switchType,
          proposedPayMethod: decoded.proposedPayMethod,
          electricitySmartMeterInstalled: decoded.electricitySmartMeterInstalled == 'true',
          gasSmartMeterInstalled: decoded.gasSmartMeterInstalled == 'true',
          includeAllPayMethodOptions: true,
          exchanged: true
        }
      }, { root: true });

      return false;
    } catch (e) {
      console.log(e);
      return true;
    }
  }
};

const mutations = {
  updateState(state, { prop, value }) {
    state[prop] = value;
  },
  updateUniqueSuppliers(state, results) {
    const unique = Array.from(new Set(results.map(s => s.supplierId)));
    const suppliers = unique.map(id => ({
      id,
      name: results.find(s => id === s.supplierId).supplierName
    }));

    state.filters.suppliers = suppliers;
  }
};

function decodeBase64(str) {
  const decodedString = atob(str);
  const [
    completionDate,
    switchId,
    switchType,
    proposedPayMethod,
    electricitySmartMeterInstalled, gasSmartMeterInstalled
  ] = decodedString.split('-*-');
  console.log([
    completionDate,
    switchId,
    switchType,
    proposedPayMethod,
    electricitySmartMeterInstalled, gasSmartMeterInstalled
  ]);

  return {
    completionDate,
    switchId,
    switchType,
    proposedPayMethod,
    electricitySmartMeterInstalled,
    gasSmartMeterInstalled
  };
}

function validateDecodeBase64(object, keys) {
  for (let index = 0; index < keys.length; index++) {
    const key = keys[index];
    if (!object[key]) throw new Error('Missing required field');
  }

  return true;
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
